import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aba-macarrao-cadastro-produtos',
  templateUrl: './aba-macarrao-cadastro-produtos.component.html',
  styleUrls: ['./aba-macarrao-cadastro-produtos.component.scss']
})
export class AbaMacarraoCadastroProdutosComponent implements OnInit {
  tamanhosMacarrao: string[] = [
    'Pequeno',
    'Médio',
    'Grande'
  ];

  constructor() { }

  ngOnInit() { }

}
